module.exports = __webpack_public_path__ + "img/pdf-svg.725dc2d5.svg";